// src/pages/Pricing.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Pricing = () => {
  const { language } = useLanguage();
  const isArabic = language === 'ar';

  const plans = isArabic ? [
    { title: 'الخطة المجانية', price: '0 د.ك', features: ['عدد محدود من الطلبات', 'دعم أساسي', 'تجربة النظام'] },
    { title: 'الخطة المتقدمة', price: '15 د.ك / شهر', features: ['طلبات غير محدودة', 'تقارير مفصلة', 'دعم عبر الهاتف'] },
    { title: 'الخطة المخصصة', price: 'تواصل معنا', features: ['حلول خاصة للسلاسل', 'ربط مع أنظمة أخرى', 'مدير حساب شخصي'] }
  ] : [
    { title: 'Free Plan', price: '0 KWD', features: ['Limited orders', 'Basic support', 'Trial usage'] },
    { title: 'Advanced Plan', price: '15 KWD / month', features: ['Unlimited orders', 'Detailed reports', 'Phone support'] },
    { title: 'Custom Plan', price: 'Contact us', features: ['Custom integrations', 'Chain support', 'Dedicated account manager'] }
  ];

  const containerStyle = {
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '20px',
    direction: isArabic ? 'rtl' : 'ltr',
    textAlign: isArabic ? 'right' : 'left',
    fontFamily: isArabic ? 'Cairo, sans-serif' : 'Segoe UI',
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap'
  };

  return (
    <div style={{ padding: '30px' }}>
      <h1 style={{ textAlign: 'center', color: '#3498db' }}>
        {isArabic ? 'خطط الأسعار' : 'Pricing Plans'}
      </h1>
      <div style={containerStyle}>
        {plans.map((plan, idx) => (
          <div key={idx} style={{
            border: '1px solid #ccc',
            borderRadius: '10px',
            padding: '20px',
            width: '300px',
            margin: '10px'
          }}>
            <h2 style={{ color: '#2c3e50' }}>{plan.title}</h2>
            <h3 style={{ color: '#27ae60' }}>{plan.price}</h3>
            <ul>
              {plan.features.map((feat, i) => (
                <li key={i}>✓ {feat}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Pricing;
